import { http } from '@/lib/http';
import type { ListQuery, Page } from '@/types/common';
import type { Organization, OrganizationCreatePayload } from '@/types/platform';

const BASE = '/api/v1/platform/organizations';

export interface OrganizationListQuery extends ListQuery {
  tenantId?: string;
}

export const organizationsService = {
  list: (query: OrganizationListQuery = {}) =>
    http.get<Page<Organization>>(BASE, { params: query }),
  get: (id: string) => http.get<Organization>(`${BASE}/${id}`),
  create: (payload: OrganizationCreatePayload) =>
    http.post<Organization, OrganizationCreatePayload>(BASE, payload),
  update: (id: string, payload: Partial<OrganizationCreatePayload>) =>
    http.patch<Organization, Partial<OrganizationCreatePayload>>(`${BASE}/${id}`, payload),
};
